export const AUTH_ABOUT_OPEN_SOURCE_LICENSES_LINK =
  '/static/third-party-notices.txt'

export const QA_NAME_AUTH_ABOUT_OPEN_SOURCE_LICENSES_LINK =
  'authAboutOpenSourceLicensesLink'

export const QA_NAME_AUTH_ABOUT_SIGN_IN_LINK = 'authAboutSignInLink'
